/**
 * SSO через Drafter ID (B-1973). Вход/регистрация — только на `id.drafter.ru`.
 * У Акселератора своей формы нет.
 *
 * Механика: после входа на `id.drafter.ru` в браузере лежит общая httpOnly-cookie
 * `token` на `Domain=.drafter.ru` (её JS не видит). Браузер сам прикладывает её к
 * запросам на `api.accelerator.drafter.ru` (поддомен `.drafter.ru`), если слать с
 * `credentials: 'include'`. Бэкенд Акселератора читает и расшифровывает cookie в
 * `exchange-drafter` и выдаёт локальный access.
 *
 * - `exchangeViaCookie()` — обменять cookie на локальный сеанс (без Bearer).
 * - `redirectToDrafterId()` — уйти на форму входа IdP с адресом возврата.
 */

import axios from "axios";

const API_BASE: string = import.meta.env.VITE_API_URL || "/api";
const DRAFTER_ID_URL: string = import.meta.env.VITE_DRAFTER_ID_URL || "https://id.drafter.ru";

export interface DrafterUserSummary {
  id: number;
  name: string | null;
  surname: string | null;
  roles: string[];
  is_admin: boolean;
  is_mentor: boolean;
}

export interface ExchangeResult {
  accessToken: string;
  /**
   * По контракту поле обязательное. `?` — страховка границы: 200 без `user`
   * (рассинхрон деплоя, HTML от прокси) не должен ронять вход `TypeError`'ом
   * внутри `try`. Отсутствие данных о роли трактуется как «доступа нет».
   */
  user?: DrafterUserSummary;
}

/**
 * Обменять общую cookie Драфтера на локальный access админки.
 * `withCredentials` обязателен — иначе браузер не приложит cookie `.drafter.ru`.
 * 401 → валидной cookie нет (не вошёл / протухла) → вызывающий редиректит в IdP.
 */
export async function exchangeViaCookie(): Promise<ExchangeResult> {
  const { data } = await axios.post<{ access_token: string; user?: DrafterUserSummary }>(
    `${API_BASE}/v1/auth/exchange-drafter`,
    { audience: "admin" },
    { withCredentials: true },
  );
  return { accessToken: data.access_token, user: data.user };
}

/** Уйти на форму входа `id.drafter.ru` с возвратом на текущий адрес. */
export function redirectToDrafterId(): void {
  const source = encodeURIComponent(window.location.href);
  window.location.href = `${DRAFTER_ID_URL}/auth?source=${source}`;
}
